import * as ERROR from './constants'

export const constants = ERROR

export function composeValidators(...validators: any) {
  return (...args: any) => validators.reduce((error: any, validator: any) => error || validator(...args), undefined)
}

export function validateNumber(val = ''): string | void {
  if (isNaN(parseInt(val, 10))) {
    return ERROR.NUMBER_ERROR
  }
}

export function runIfTruthy(cb: any, falseyReturn?: any) {
  return (value: any, ...args: any) => {
    if (value) {
      return cb(value, ...args)
    }

    return falseyReturn
  }
}

export const required = (value: any): string | void => {
  if (!value) {
    return ERROR.REQUIRED
  }
}

export const parseNumberPlate = (value = ''): string => {
  const validChars = value.match(/[a-z0-9]/gi) || []

  return validChars.slice(0, 7).join('').toUpperCase()
}

export const validateNumberPlate = (value = ''): string | void => {
  const allChars = value.replace(/ /g, '')
  const validChars = allChars.match(/[a-z0-9]/gi) || []

  const isInvalidLength = allChars.length < 2 || allChars.length > 7
  const hasInvalidChars = allChars.length > validChars.length

  if (isInvalidLength || hasInvalidChars) {
    return ERROR.NUMBER_PLATE
  }
}

export const validatePassword = runIfTruthy((value: string): string | void => {
  const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/
  const re = new RegExp(regex)
  if (value && !value.match(re)) {
    return ERROR.INVALID_PASSWORD
  }
})

export const email = runIfTruthy((value: string): string | void => {
  // w3 standard. https://www.w3.org/TR/2012/WD-html-markup-20120320/input.email.html
  const regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  const re = new RegExp(regex)
  if ((value && !value.match(re)) || value.length > 50) {
    return ERROR.INVALID_EMAIL
  }
}, undefined)

export const comparePassword = (compareKey: string) =>
  runIfTruthy((value: string, { [compareKey]: newPassword }: any): string | void => {
    if (!!value && newPassword !== value) {
      return ERROR.PASSWORD_MISMATCH
    }
  })

export const validatePhoneNumber = runIfTruthy((value: string): string | void => {
  if (value.length && (value.length < 10 || value.length > 15)) {
    return ERROR.TEL_LENGTH_BREACH
  } else {
    const match = value.match(/[0-9+()\s]*/)
    if (value.length && (!match || !match.length || match[0] !== value)) {
      return ERROR.INVALID_TEL
    }
  }
})

export const validateMarketingPreferences = (allValues: any) => {
  if (!allValues.preferenceEmail && !allValues.preferenceSms && !allValues.preferenceDigital) {
    return ERROR.MARKETING_PREF
  }
}

export const validateRange = (value: number, range: { min: number; max: number }) => {
  if (isNaN(value)) {
    return false
  }

  return value >= range.min && value <= range.max
}

export const validateMonth = (value: string | undefined) => {
  if (!value) {
    return ERROR.REQUIRED
  }

  const number = parseInt(value, 10)

  if (isNaN(number)) {
    return ERROR.NUMBER_ERROR
  }

  if (number === 12) {
    return ERROR.MONTHS_USE_YEARS_ERROR
  }

  if (number > 12) {
    return ERROR.MONTHS_ERROR
  }
}
